module.exports = __webpack_public_path__ + "static/media/img-epaper-bg-UNSUB-M.7aaebdef.webp";